/** @format */

import React, { useState, useEffect } from 'react'
import {
  Select,
  Option,
  Checkbox,
  Icon,
  TableColumn,
  Table,
  Button,
  _$,
  Tag
} from '@king-design/react'
import request from 'src/utils/request'
import API, { getScheduleList } from 'src/api/ApiContacts'
import { useAsync } from 'react-use'
import { cloneDeep } from 'lodash'
import { ScheduleItemProps } from 'src/pages/MonitorAlarm/MonitorAlarmTarget/Schedule/interface'

// 平台提供全局方法
const ksStorage = window['__ksStorage__']
// 支持电话通知的客户
const supportPhoneCustomer = [73401193, 73408594, 2000015685, 73408953, 73398680]
// way->channels
const ChannelEnum = {
  1: [1],
  2: [2],
  3: [1, 2]
}
export const handleWayToChannels = (way: number | number[]) => {
  return Array.isArray(way) ? way : ChannelEnum[way] || []
}

export interface ConcatProps {
  ContactID: string | number
  ContactName?: string
  ContactFlag: number
  ContactChannels: number[]
}

export interface UserItemProps {
  userid: number
  name: string
}
export interface GroupItemProps {
  usrgrpid: number
  name: string
}

interface AlarmReciverProps {
  value?: ConcatProps[]
  onChange?: (data: ConcatProps[]) => void
  maxLength?: number
  style?: React.CSSProperties
  readonly?: boolean
  userlist?: UserItemProps[]
  grouplist?: GroupItemProps[]
  showSchedule?: boolean
  schedulelist?: ScheduleItemProps[]
  showPhone?: boolean // 是否支持电话
}

export const reciverScheme = {
  ContactFlag: {
    title: _$('类型'),
    width: '100',
    template: item => {
      return ContactFlagEnum[item?.ContactFlag] || ''
    }
  },
  ContactName: {
    title: _$('名称')
  },
  ContactChannels: {
    title: _$('通知方式'),
    template: item => {
      return (
        item?.ContactChannels?.map(item => ContactChannelsEnum[item]).join(',') ||
        item.ContactWay ||
        '-'
      )
    }
  }
}

// 通知结果
export const NotificationResultEnum = {
  email: _$('邮箱'),
  phone: _$('电话'),
  sms: _$('短信')
}

export const notificationResultScheme = {
  ContactFlag: {
    title: _$('类型'),
    width: '100',
    template: item => {
      return ContactFlagEnum[item?.ContactFlag] || ''
    }
  },
  Name: {
    title: _$('名称'),
    width: '120'
  },
  NotificationResult: {
    title: _$('结果'),
    template: item => {
      return Object.entries(item?.NotificationResult)?.map(([key, value]) => {
        const { resason, status } = value as { resason: string; status: string }
        return (
          <p>
            {NotificationResultEnum[key]}：
            <Tag type={status === 'success' ? 'success' : 'danger'}>
              {status === 'success' ? _$('发送成功') : resason}
            </Tag>
          </p>
        )
      })
    }
  }
}

export const ContactFlagEnum = {
  1: _$('联系组'),
  2: _$('联系人'),
  3: _$('值班表')
}
export const ContactChannelsEnum = {
  1: _$('邮箱'),
  2: _$('短信'),
  16: _$('电话')
}
const AlarmReciver: React.FC<AlarmReciverProps> = ({
  value = [],
  onChange,
  maxLength = 10,
  style,
  readonly = false,
  userlist: userListProp,
  grouplist: grouplistProp,
  showSchedule = false,
  schedulelist,
  showPhone
}) => {
  const [checkSupportPhone, setCheckSupportPhone] = useState(false)

  useEffect(() => {
    ksStorage?.getBaseInfo('userInfo', function (data) {
      if (data && data.user) {
        const { id } = data.user
        if (id && supportPhoneCustomer.includes(id)) {
          setCheckSupportPhone(true)
        }
      }
    })
  }, [])

  const { value: userList } = useAsync(async () => {
    if (userListProp?.length) {
      return userListProp
    } else {
      const result = await request(API.getAlertUser, {
        method: 'get',
        data: {
          PageIndex: 1,
          Cap: 1
        }
      })
      return result?.data?.userlist?.filter(item => item.status === 1) || []
    }
  }, [userListProp])

  const { value: groupList } = useAsync(async () => {
    if (grouplistProp?.length) {
      return grouplistProp
    } else {
      const result = await request(API.getUserGroup, {
        method: 'get',
        data: {
          PageIndex: 1,
          Cap: 1
        }
      })
      return result?.data?.usergrplist || []
    }
  }, [grouplistProp])

  const { value: scheduleList } = useAsync(async () => {
    if (!showSchedule) return []
    if (schedulelist?.length) {
      return schedulelist
    } else {
      const result = await getScheduleList({
        Page: 1,
        PageSize: 9999
      })
      return result?.List.filter(item => item.Status === 'active')
    }
  }, [showSchedule, schedulelist])

  const onTableChange = (data, index) => {
    const clone = cloneDeep(value)
    clone[index] = { ...clone[index], ...data }
    onChange && onChange(clone)
  }

  return (
    <div className="alarm_reciver" style={style || {}}>
      <Table data={value || []} animation={false} rowKey={data => data.ContactID} checkType="none">
        <TableColumn
          key="ContactFlag"
          width="70"
          title={_$('类型')}
          slotTemplate={([data, index]) => {
            const { ContactFlag } = data
            return <span>{_$(ContactFlagEnum[ContactFlag])}</span>
          }}
        />
        <TableColumn
          key="ContactName"
          title={_$('接收人')}
          slotTemplate={([data, index]) => {
            const { ContactFlag, ContactName, ContactID } = data
            return readonly ? (
              <span>
                {ContactName}({_$(ContactFlagEnum[ContactFlag])})
              </span>
            ) : (
              <Select
                filterable
                container={() => document.getElementsByClassName('alarm_reciver')[0]}
                value={ContactID}
                width="270"
                placeholder={`${_$('请选择')} ${_$(ContactFlagEnum[ContactFlag])}`}
                onChangeValue={value => {
                  let find = null
                  if (ContactFlag === 1) {
                    find = groupList?.find(item => item.usrgrpid === value)
                  } else if (ContactFlag === 2) {
                    find = userList?.find(item => item.userid === value)
                  } else if (ContactFlag === 3) {
                    find = scheduleList?.find(item => item.ScheduleID === value)
                  }
                  onTableChange({ ContactID: value, ContactName: find?.Name }, index)
                }}
              >
                {/* 1=联系组 2=联系人 */}
                {ContactFlag === 1
                  ? groupList?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 1 && item.ContactID === opt.usrgrpid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.usrgrpid} value={opt.usrgrpid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
                {ContactFlag === 2
                  ? userList?.map(opt => {
                      const disabled = value.find(
                        item => item.ContactFlag === 2 && item.ContactID === opt.userid
                      )
                      return (
                        <Option disabled={!!disabled} key={opt.userid} value={opt.userid}>
                          {opt.name}
                        </Option>
                      )
                    })
                  : null}
                {showSchedule && ContactFlag === 3
                  ? scheduleList?.map(opt => {
                      return (
                        <Option key={opt.ScheduleID} value={opt.ScheduleID}>
                          {opt.Name}
                        </Option>
                      )
                    })
                  : null}
              </Select>
            )
          }}
        />
        <TableColumn
          key="ContactChannels"
          title={_$('通知方式')}
          width="180"
          slotTemplate={([data, index]) => {
            return readonly ? (
              <span>{data.ContactChannels?.map(item => _$(ContactChannelsEnum[item]))}</span>
            ) : (
              <div className="ksc-space">
                <Checkbox
                  name="channels"
                  trueValue={1}
                  value={data.ContactChannels}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    newData[index].ContactChannels = val
                    onChange(newData)
                  }}
                >
                  {_$('邮箱')}
                </Checkbox>
                <Checkbox
                  name="channels"
                  trueValue={2}
                  value={data.ContactChannels}
                  onChangeValue={val => {
                    const newData = cloneDeep(value)
                    newData[index].ContactChannels = val
                    onChange(newData)
                  }}
                >
                  {_$('短信')}
                </Checkbox>
                {showPhone && checkSupportPhone ? (
                  <Checkbox
                    name="channels"
                    trueValue={16}
                    value={data.ContactChannels}
                    onChangeValue={val => {
                      const newData = cloneDeep(value)
                      newData[index].ContactChannels = val
                      onChange(newData)
                    }}
                  >
                    {_$('电话')}
                  </Checkbox>
                ) : null}
              </div>
            )
          }}
        />
        <TableColumn
          key="operate"
          title={_$('操作')}
          hidden={readonly}
          width="60"
          slotTemplate={([data, index]) => {
            return (
              <a
                onClick={() => {
                  const clone = cloneDeep(value)
                  clone.splice(index, 1)
                  onChange && onChange(clone)
                }}
              >
                {_$('删除')}
              </a>
            )
          }}
        ></TableColumn>
      </Table>

      {readonly ? null : (
        <p style={{ margin: 0, lineHeight: '32px' }}>
          <Button
            disabled={value.length >= maxLength}
            type="link"
            onClick={() => {
              onChange([
                ...value,
                {
                  ContactID: '',
                  ContactName: '',
                  ContactFlag: 1,
                  ContactChannels: [1]
                }
              ])
            }}
          >
            <Icon color="#0091ea" className="ion-plus-round" />
            {_$('新建联系组')}
          </Button>

          <Button
            disabled={value.length >= maxLength}
            type="link"
            onClick={() => {
              onChange([
                ...value,
                {
                  ContactID: '',
                  ContactName: '',
                  ContactFlag: 2,
                  ContactChannels: [1]
                }
              ])
            }}
          >
            <Icon color="#0091ea" className="ion-plus-round" />
            {_$('新建联系人')}
          </Button>

          {showSchedule ? (
            <Button
              disabled={value.length >= maxLength}
              type="link"
              onClick={() => {
                onChange([
                  ...value,
                  { ContactID: '', ContactName: '', ContactFlag: 3, ContactChannels: [1] }
                ])
              }}
            >
              <Icon color="#0091ea" className="ion-plus-round" />
              {_$('新建值班表')}
            </Button>
          ) : null}
        </p>
      )}
    </div>
  )
}

export default AlarmReciver
